import { render, staticRenderFns } from "./AskForPermissionDialog.vue?vue&type=template&id=4ce7db58&lang=pug"
import script from "./AskForPermissionDialog.vue?vue&type=script&lang=js"
export * from "./AskForPermissionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports